import { useVersionCheck } from "../hooks/useVersionCheck";

export const UpdateNotification = () => {
  const { needsRefresh, handleRefresh } = useVersionCheck();

  if (!needsRefresh) return null;

  return (
    <div className="fixed top-4 right-4 bg-blue-500 text-white p-4 rounded-lg shadow-lg z-[9999] flex items-center gap-4 animate-fade-in">
      <span>A new version is available!</span>
      <button
        onClick={handleRefresh}
        className="bg-white text-blue-500 px-4 py-2 rounded hover:bg-blue-50 transition-colors"
      >
        Refresh Now
      </button>
    </div>
  );
};
